import AiForm from "@/components/AiForm";
import Layout from "@/components/layout";
import { FC, useState , useContext, useEffect} from "react";
import { useRouter } from "next/router";
import Head from "next/head";
import { AuthContext } from "@/context/AuthContext";
import SeoComponent from "@/components/AiForm/SeoComponent";
interface indexProps {}

const Index: FC<indexProps> = ({}) => {
	const router = useRouter();
	const user = useContext(AuthContext);
	const [showForm,setShowForm]=useState(false)

	useEffect(()=>{
		if(user){
			setShowForm(true)
		}
	},[user])

	function revealForm(){
		setShowForm(true)
	}
	//add canonical tag
	const canonicalUrl = (
		`https://instantapply.co/ai` + (router.asPath === "/" ? "" : router.asPath)
	).split("?")[0];
	return (
		
		<>
			<Layout>
				<Head>
					<title>
						Create Powerful Cover Letters with AI | Free Cover Letter Generator
					</title>
					<meta
						name='title'
						property='og:title'
						content='Create Powerful Cover Letters with AI | Free Cover Letter Generator'
					/>
					<meta
						name='keywords'
						content='cover letter generator, AI cover letter, free cover letter, job application, AI resume'
					/>
					<meta
						name='description'
						content='Easily craft compelling cover letters with our free AI cover letter generator. Get personalized, professionally-written cover letters for your job applications.'
					/>
					<link rel='icon' href='/favicon.ico' />
					<link rel='canonical' href={canonicalUrl} key='canonical' />

					{/* Open Graph / Facebook */}
					<meta property='og:type' content='website' />
					<meta property='og:url' content='https://instantapply.co/ai' />
					<meta
						property='og:title'
						content='Create Powerful Cover Letters with AI | Free Cover Letter Generator'
					/>
					<meta
						name='description'
						property='og:description'
						content='Easily craft compelling cover letters with our free AI cover letter generator. Get personalized, professionally-written cover letters for your job applications.'
					/>
					<meta property='og:site_name' content='https://instantapply.co' />
					<meta
						name='image'
						property='og:image'
						content='https://yauoagpuebtzbgpptwsp.supabase.co/storage/v1/object/public/image/instantapply-image.png'
					/>

					{/* Twitter */}
					<meta property='twitter:card' content='summary_large_image' />
					<meta property='twitter:url' content='https://instantapply.co/ai' />
					<meta property='twitter:site' content='@instantapplyco' />
					<meta
						property='twitter:title'
						content='Create Powerful Cover Letters with AI | Free Cover Letter Generator'
					/>
					<meta
						property='twitter:description'
						content='Easily craft compelling cover letters with our free AI cover letter generator. Get personalized, professionally-written cover letters for your job applications.'
					/>
					<meta
						property='twitter:image'
						content='https://yauoagpuebtzbgpptwsp.supabase.co/storage/v1/object/public/image/instantapply-image.png'
					/>
					<meta name='next-head-count' content='23' />
				</Head>
				{showForm&&<AiForm />}
				{!showForm&&<SeoComponent revealForm={revealForm} />}
				
			</Layout>
		</>
	);
};

// export const getServerSideProps = async (ctx: GetServerSidePropsContext) => {
//   // Create authenticated Supabase Client
//   const supabase = createServerSupabaseClient(ctx);
//   // Check if we have a session
//   const {
//     data: { session },
//   } = await supabase.auth.getSession();
//   //get user belonging to that session

//   const user = session ? session.user : null;
//   if (!user) {
//     return {
//       redirect: {
//         destination: "/",
//         permanent: false,
//       },
//     };
//   } else {
//     const result = await getUserOnboardingStatus(user);
//     if (result && result[0].onboarding !== 2) {
//       return {
//         redirect: {
//           destination: "/onboarding",
//           permanent: false,
//         },
//       };
//     }
//   }

//   return {
//     props: { session },
//   };
// };
export default Index;
